    <template>
        <div class="sw-modal edit-form-component">
            <div v-click-outside="cancel" class="sw-modal-content">
                <div class="row sw-modal-heading">
                    <div class="col"><h4><i class="fas fa-cog"></i>Establishment Settings</h4></div>
                </div>
                <div class="sw-modal-body">
                    <div class="row question">
                        <div class="col-12 question__question">
                            Name
                        </div>
                        <div class="col-12">
                            <template v-if="isPMSEstablishment">
                                {{copy.name}}
                            </template>
                            <template v-else>
                                <input type="text" v-model="copy.name" class="short-question">
                            </template>
                        </div>
                    </div>
                    <template v-if="isPMSEstablishment">
                        <div class="row question">
                            <div class="col-12 question__question">
                                Channel Manager
                            </div>
                            <div class="col-12">
                                {{copy.provider.name}}
                            </div>
                        </div>
                        <div class="row question">
                            <div class="col-12 question__question">
                                {{copy.provider.establishmentExternalIDLabel}}
                            </div>
                            <div class="col-12">
                                <input type="text" v-model="copy.externalId" class="short-question" readonly>
                            </div>
                        </div>
                    </template>
                    <div class="row question">
                        <div class="col-12 question__question">
                            PMS
                        </div>
                        <div class="col-12">
                            <select v-model="copy.propertyManagementSystem">
                                <option value="">Please select your PMS</option>
                                <option value="bridge-it">BridgeIT</option>
                                <option value="hotelier">Hotelier</option>
                                <option value="semper">Semper</option>
                                <option value="inn-keeper">InnKeeper</option>
                            </select>
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Time zone
                        </div>
                        <div class="col-12">
                            <select v-model="copy.timeZone">
                                <option v-for="(timeZone, index) in timeZones" v-bind:key="index" v-bind:value="timeZone.timeZone">{{timeZone.display}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Contact person
                        </div>
                        <div class="col-12">
                            <template v-if="isPMSEstablishment">
                                {{copy.contactInfo.contact}}
                            </template>
                            <template v-else>
                                <input type="text" v-model="copy.contactInfo.contact" class="short-question">
                            </template>
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Reservations email
                        </div>
                        <div class="col-12">
                            <template v-if="isPMSEstablishment">
                                {{copy.contactInfo.email}}
                            </template>
                            <template v-else>
                                <input type="text" v-model="copy.contactInfo.email" class="short-question">
                            </template>
                        </div>
                    </div>
                    <div class="row question">
                        <div class="col-12 question__question">
                            Mobile
                        </div>
                        <div class="col-12">
                            <template v-if="isPMSEstablishment">
                                {{copy.contactInfo.mobile}}
                            </template>
                            <template v-else>
                                <input type="text" v-model="copy.contactInfo.mobile" class="short-question">
                            </template>
                        </div>
                    </div>
                </div>
                <div class="sw-modal-actions">
                    <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                        {{infoMessage}}
                    </div>
                    <div v-show="updating && !success">
                        <Spinner/>
                    </div>
                    <div class="row" v-show="!updating && !success">
                        <div class="col text-center">
                            <button class="btn btn-secondary" v-on:click="cancel">Cancel</button>
                            <button class="btn btn-primary" v-on:click="save">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

<script>
    import { store } from '../../store.js'
    import Spinner from '../Spinner.vue'

    export default {
        name: 'EditSettings',
        components: {
            Spinner
        },
        props: {
            establishment: Object
        },
        data: function() {
            return {
                timeZones: [],
                copy: {
                    name: "",
                    timeZone: "",
                    contactInfo: {
                        contact: "",
                        email: "",
                        mobile: ""
                    }
                },
                loading: false,
                updating: false,
                error: false,
                success: false,
                infoMessage: "",
            }
        },
        computed: {
            isPMSEstablishment: function() {
                if (this.copy.provider) {
                    return true;
                }
                return false;
            },
        },
        methods: {
            reset: function() {
                // reset form to initial state
                this.infoMessage = null;
            },
            cancel: function() {
                console.log("cancel");
                this.establishment.name = this.copy.name;
                this.$root.$emit('finished-editing-establishment-settings');
            },
            save: function() {
                console.log("saving establishment");
                this.error = false;

                let body = {
                    "reference": this.copy.reference,
                    "name": this.copy.name,
                    "timeZone": this.copy.timeZone,
                    "propertyManagementSystem": this.copy.propertyManagementSystem,
                    "contactInfo": {
                    }
                };
                console.log(body);

                // updating a form template
                this.updating = true;
                this.infoMessage = "Saving establishment";
                this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference, body
                ).then(response => {
                    console.log("Establishment updated:");
                    console.log(response);
                    this.infoMessage = "Establishment updated";
                    this.success = true;
                    Object.assign(this.establishment, this.copy);
                    setTimeout(() => {
                        this.updating = false;
                        this.$root.$emit('finished-editing-establishment-settings');
                    }, 2000);
                }).catch(error => {
                    this.error = true;
                    this.updating = false;
                    if (error.response) {
                        this.infoMessage = "Error: " + error.response.data.message
                    } else {
                        this.infoMessage = "Error updating establishment";
                    }
                });
            },
            fetchTimeZones: function () {
                this.loading = true;
                this.$http.get('/guest-management/v1/data/timezones', {
                    withCredentials: true
                }).then(response => {
                    if (response.data) {
                        this.timeZones.push(...response.data);
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.loading = false;
                })
            },
        },
        mounted() {
            this.reset();
            this.copy = { ...this.establishment };
            this.fetchTimeZones();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal";
    @import "../../styles/components/edit_establishment";
    @import "../../styles/components/question_answer";
</style>